module.exports = __webpack_public_path__ + "img/instagramB.8af0c0d2.png";